import store from "../store";
import {
  getProjectAll,
  getCompanyAll,
  getDepartmentAll,
  allPosition,
} from "@/api/user";

import { getGeneralBasic, getEmploymentFormAll } from "@/api/table";

export const getAllData = async (type) => {
  let newArray = [];
  switch (type) {
    case 1: //项目部
      if (store.state.projectList && store.state.projectList.length === 0) {
        await getProjectAll().then((res) => {
          if (res.status === 200) {
            store.commit("changeProjectList", res.response || []);
          }
        });
      }

      newArray = store.state.projectList;
      break;

    case 2: //用工单位
      if (store.state.companyList && store.state.companyList.length === 0) {
        await getCompanyAll().then((res) => {
          if (res.status === 200) {
            store.commit("changeCompanyList", res.response || []);
          }
        });
      }
      newArray = store.state.companyList;
      break;
    case 3: //部门
      if (
        store.state.departmentList &&
        store.state.departmentList.length === 0
      ) {
        await getDepartmentAll().then((res) => {
          if (res.status === 200) {
            store.commit("changeDepartmentList", res.response || []);
          }
        });
      }
      newArray = store.state.departmentList;
      break;

    case 4: //岗位
      if (store.state.positionList && store.state.positionList.length === 0) {
        await allPosition().then((res) => {
          if (res.status === 200) {
            store.commit("changePositionList", res.response || []);
          }
        });
      }
      newArray = store.state.positionList;
      break;

    case 5: //国籍
      if (store.state.countries && store.state.countries.length === 0) {
        await getGeneralBasic().then((res) => {
          if (res.status === 200) {
            store.commit("changeCountries", res.response.Countries || []);
          }
        });
      }
      newArray = store.state.countries;
      break;

    case 6: //用工形式
      if (store.state.employmentForm && store.state.employmentForm.length === 0) {
        await getEmploymentFormAll().then((res) => {
          if (res.status === 200) {
            store.commit("changeEmploymentForm", res.response || []);
          }
        });
      }
      newArray = store.state.employmentForm;
      break;
  }
  return newArray;
};
